<template>
  <div class="ui-content dashboard user-section user-height">
    <v-card class="mx-auto normal-card autohg">
      <div class="data-table-section" ref="infoBox">
        <v-data-table
          :headers="headers"
          fixed-header
          :items="items"
          hide-default-header
          hide-default-footer
          class="elevation-2 cust-table"
        >
          <template v-slot:header="{ props: { headers } }">
            <TableHeader
              :headers="headers"
              :onHeaderAction="onHeaderAction"
              :orderBy="orderBy"
              :onSortChange="onSortChange"
            />
          </template>

          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="(item, index) in items" :key="index">
                <td class="check-50">
                  <div class="check-cust">
                    <v-checkbox v-model="item.checked"></v-checkbox>
                  </div>
                </td>
                <td>{{ item.name }}</td>
                <td class="text-alignment">{{ item.email }}</td>
                <td class="text-alignment">{{ item.class_code }}</td>
                <td class="text-alignment">
                  {{ compareSubjects(item.subjects) }}
                </td>
                 <td class="text-alignment" v-model="showToolTip" :disabled="!buttonHovering"> <v-tooltip bottom content-class="cust-new-tooltip-top open-top">
										<template v-slot:activator="{ on }">
                      <v-hover v-model="buttonHovering">
                        	<span
											v-on="on"
											depressed
												:class="{
												'text-transform-none': true,
												'btn-center': true,
												'btn-default': true,
											}"
											
											>{{compareCenters(item.center).length< 10 ? compareCenters(item.center):compareCenters(item.center).substring(0,10) + '...'}}</span
											>
                         
                      </v-hover>
										
										</template>
										<span>{{compareCenters(item.center)}} </span>
										</v-tooltip>
								</td>
                <td class="text-alignment"  v-model="showToolTip" :disabled="!buttonHovering"> <v-tooltip bottom content-class="cust-new-tooltip-top open-top">
										<template v-slot:activator="{ on }">
                      <v-hover  v-model="buttonHovering">
                        <span
										   	v-on="on"
											  depressed
												:class="{
												'text-transform-none': true,
												'btn-center': true,
												'btn-default': true,
											}"
											
											>{{compareBatches(item.batch).length< 10 ? compareBatches(item.batch):compareBatches(item.batch).substring(0,10) + '...'}}</span
											>

                      </v-hover>
											
										</template>
										<span>{{compareBatches(item.batch)}} </span>
										</v-tooltip>
								</td>
                <td class="blank-80" @click="editTeacherDialog(item)">
                  <v-tooltip left content-class="cust-tooltip">
                    <template v-slot:activator="{ on }">
                      <v-icon class="pencil-icon" v-on="on">mdi-pencil</v-icon>
                    </template>
                    <span>Edit Teacher/Category/Subject</span>
                  </v-tooltip>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <AlertBox
          width="450px"
          :onClose="onClose"
          component="components/coordinator/users/ApprovedUsers/EditTeacherDetails"
          :status="status"
          :data="selctedUserForEdit"
        />
      </div>
    </v-card>
    <div class="footer-btn">
      <div class="pull-left">
        <v-btn
          :loading="loading"
          @click="requestApproveOrDisapproveUser(1)"
          class="right-btn cust-btn"
          color="primary"
          >Approve</v-btn
        >
        <v-btn
          :loading="loading"
          @click="requestApproveOrDisapproveUser(-1)"
          class="right-btn cust-btn"
          color="primary"
          >Disapprove</v-btn
        >
      </div>
      <div class="pull-right">
        <Pagination
          :currentPage="currentPage"
          :totalPage="totalPages"
          :onPageChange="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "UsersTeacher",
  data() {
    return {
      loading: false,
      items: [],
      orderBy: {
        field: "name",
        order: "ASC",
      },
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      subjects: [],
      subjectID: [],
      stringSubject: [],
      selctedUserForEdit: {},
      status: false,
      selectedCenterId: null,
      batches: [],
      buttonHovering: false,
      showToolTip: false

    };
  },
  methods: {
    ...mapActions({
      getSelfSignedUpUsers: "userStore/getSelfSignedUpUsers",
      getDataTreeWithLevel: "utilStore/getDataTreeWithLevel",
      approveOrDisapproveUser: "userStore/approveOrDisapproveUser",
      getCentersByUser: "centerAndBatchStore/getCentersByUser",
      getBatches: "centerAndBatchStore/getBatches",
    }),
    requestApproveOrDisapproveUser(status) {
      let user_ids = [];
      if (this.items && this.items.length) {
        user_ids = this.items.filter((i) => i.checked).map((u) => u.id);
        if (!user_ids || user_ids.length < 1) {
          return this.$toasted.error(`Select atleast one user`);
        }
        let reqData = {
          role_id: this.roleIds.TR,
          status: status,
          user_ids: user_ids,
        };
        this.loading = true;
        this.approveOrDisapproveUser(reqData)
          .then((response) => {
            this.loading = false;
            this.requesGetSelfSignedUpUsers();
            this.$toasted.success(`Success\n${response.message}`, {
              icon: "check_circle",
            });
          })
          .catch((err) => {
            this.loading = false;
          });
      }
    },
    onClose(data) {
      this.status = data.status;
      if (data.reload) {
        this.requesGetSelfSignedUpUsers();
      }
    },
    getSubjects(subjects) {
      let reqData = {
        level: 2,
      };
      this.subjects = [];
      this.$root.showLoader = true;
      this.getDataTreeWithLevel(reqData).then((response) => {
        this.$root.showLoader = false;
        this.subjects = response;
      }).catch((err) => {
          this.$root.showLoader = false;
        });
    },
    requesGetSelfSignedUpUsers() {
      let reqData = {
        role_id: this.roleIds.TR,
        is_approved: 0,
        active: 1,
        orderBy: this.orderBy,
        pagination: { page: this.currentPage, pageSize: this.pageSize },
      };
      this.$root.showLoader = true;
      this.getSelfSignedUpUsers(reqData)
        .then((response) => {
          this.items = response.list.map((u) => {
            u.checked = false;
            return u;
          });
          this.totalPages = response.pagination.pageCount;
          this.$root.showLoader = false;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    compareSubjects(subjects) {
      let userSubjects = [];
      if (subjects.length) {
        this.subjects.map((m) => {
          if (subjects.includes(m.id)) {
            userSubjects.push(m.title);
          }
        });
      }
      return userSubjects.join(", ");
    },
    requestGetCenters() {
      this.$root.showLoader = true;
      this.centers = [];
      this.centersList = [];
      this.getCentersByUser()
        .then((response) => {
          this.centers = response;
          this.$root.showLoader = false;
          let centerIds = [];
          this.centersList = response.map((x) => {
            centerIds.push(x.id);
            let c = {};
            c.text = x.name;
            c.value = x.id;
            return c;
          });
         
          this.onCenterSelect(centerIds);
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    compareCenters(centers) {
      let userCenters = [];
      if (centers.length) {
        this.centers.map((m) => {
          if (centers.includes(m.id)) {
            userCenters.push(m.name);
          }
        });
       
      }
      return userCenters.join(", ");
    },
     onCenterSelect(centerIds) {
      if (centerIds && centerIds.length) {
        this.$root.showLoader = true;
        this.batches = [];
        this.getBatches({ center_id: centerIds })
          .then((response) => {
            if (response && response.list && response.list.length) {
              this.batches = response.list;
             
            } 
        this.$root.showLoader = false;

          })
          .catch((err) => {
            this.$root.showLoader = false;
          });
      } 
    },
    compareBatches(batches) {
      let userBatches = [];
      if (batches.length && this.batches.length) {
        this.batches.map((m) => {
          if (batches.includes(m.id)) {
            userBatches.push(m.name);
          }
        });
      
      }
      return userBatches.join(", ");
    },
    onHeaderAction(e) {
      if (e.header && e.header.type === "check") {
        if (e.data) {
          this.items = this.items.map((u) => {
            u.checked = e.data.checked;
            return u;
          });
        }
      }
    },
    onSortChange() {
      this.requesGetSelfSignedUpUsers();
    },
    onPageChange(e) {
      this.currentPage = e;
      this.requesGetSelfSignedUpUsers();
    },
    editTeacherDialog(user) {
      this.selctedUserForEdit = user;
      this.status = true;
    },
    
  },
  mounted() {
    this.requesGetSelfSignedUpUsers();
    this.getSubjects();
    this.requestGetCenters();
  },
  watch: {
    buttonHovering (val) {
        
      this.showToolTip = val;
    },

  },
  computed: {
    headers() {
      return [
        {
          text: "",
          value: "check",
          type: "check",
          class: "check-50",
          checked: this.isAllUserSelected,
        },

        { text: "Name", value: "name" },
        { text: "Email ID", value: "email", class: "text-center" },
        { text: "Category", value: "category", class: "text-center width-120 " },
        { text: "Subject", value: "subjects", class: "text-center" },
        { text: "Center", value: "center", class: "text-center width-200" },
        { text: "Batch", value: "batch", class: "text-center width-120 " },
        { text: "", value: "", type: "blank", class: "blank-80" },
      ];
    },
    isAllUserSelected() {
      if (this.items && this.items.length) {
        let tmpArry = this.items.filter((x) => x.checked);
        if (tmpArry) {
          return tmpArry.length === this.items.length;
        }
      }
      return false;
    },
  },
};
</script>